export const preloadTransactionForm = () => import('@/pages/TransactionFormPage');
export const preloadUpload = () => import('@/pages/UploadPage');
export const preloadJobs = () => import('@/pages/JobsPage');
export const preloadAnalytics = () => import('@/components/Analytics/AnalyticsOverview');
export const preloadTeamMembers = () => import('@/pages/TeamMembersPage');
export const preloadTeamSettings = () => import('@/pages/TeamSettingsPage');
export const preloadWebhooks = () => import('@/pages/WebhooksPage');
export const preloadModelRegistry = () => import('@/pages/ModelRegistryPage');
export const preloadApiDocs = () => import('@/pages/ApiDocsPage');
export const preloadUserGuide = () => import('@/pages/UserGuidePage/UserGuidePage');

const bySegment: Record<string, () => Promise<unknown>> = {
  '': preloadUpload,
  jobs: preloadJobs,
  analytics: preloadAnalytics,
  'team-members': preloadTeamMembers,
  'team-settings': preloadTeamSettings,
  webhooks: preloadWebhooks,
  'model-registry': preloadModelRegistry,
  docs: preloadApiDocs,
  guide: preloadUserGuide,
};

/** Unknown first segments are transaction ids, which the jobs list already prefetches on hover. */
export const preloadRoute = (path: string): void => {
  const segment = path.split('?')[0].split('/').filter(Boolean)[0] ?? '';
  void bySegment[segment]?.();
};
